import { styled } from '../../../core/theme/styled';

export const StyledPinCodeContainer = styled.div`
  width: min-content;
`;
